"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var contracts_1 = require("./contracts");
var _1 = require("./");
var diModule = new inversify_1.ContainerModule(function (bind) {
    // bind<ITokenHandler>(TYPES.ITokenHandler).to(TokenHandler).inSingletonScope();
    bind(contracts_1.TYPES.IUserHandler).to(_1.UserHandler).inSingletonScope();
});
exports.diModule = diModule;
